import { useEffect } from 'react';
import { useChannelImportStore } from '../stores/channelImport.store';

const POLL_INTERVAL_MS = 2000;

export const useChannelImport = (draftUuid?: string) => {
  const store = useChannelImportStore();
  const loadAccounts = useChannelImportStore((s) => s.loadAccounts);
  const loadRecent = useChannelImportStore((s) => s.loadRecent);
  const open = useChannelImportStore((s) => s.open);
  const reset = useChannelImportStore((s) => s.reset);
  const refresh = useChannelImportStore((s) => s.refresh);
  const isResolving = Boolean(store.draft?.isResolving);

  useEffect(() => {
    loadAccounts();
    loadRecent();
  }, [loadAccounts, loadRecent]);

  useEffect(() => {
    if (draftUuid) {
      open(draftUuid);
    } else {
      reset();
    }
  }, [draftUuid, open, reset]);

  useEffect(() => {
    if (!isResolving) return undefined;
    const timer = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [isResolving, refresh]);

  return store;
};
